import React from "react";
import {
  NoJoinLinksContainer,
  NoJoinLinksIcon,
  NoJoinLinksText,
  NoJoinLinksSubtext,
  LinkIcon,
} from "./index.styled";

const NoJoinLinks: React.FC = () => {
  return (
    <NoJoinLinksContainer>
      <NoJoinLinksIcon>
        <LinkIcon />
      </NoJoinLinksIcon>
      <NoJoinLinksText>אין קישורי הצטרפות זמינים</NoJoinLinksText>
      <NoJoinLinksSubtext>
        קישורי ההצטרפות יופיעו כאן ברגע שייווצרו
      </NoJoinLinksSubtext>
    </NoJoinLinksContainer>
  );
};

export default NoJoinLinks;
